<div class="row">
    <div class="col-md-12">
        
        <div class="sport_tab-section">
            <div class="tab-content sport_content">
                <div class="tab-pane fade show active" id="Inplay" role="tabpanel">

                    <div class="row g-4 position-relative" *ngIf="!router.url.includes('dashboard')">
                        
                        <div class="col-md-12" *ngFor="let mn of menuItems; let i=index;trackBy:trackByIndex;">
                            <!-- {{mn.id}} - {{mn.name}} - {{tabId}} -->
                            <div class="common-sports">
                                <div class="row">
                                    <div class="listuiscreen">
                                        <div class="sub_path">
                                            <p>{{mn.name}} <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/icons/{{mn.id}}.svg"></p>
                                            <div class="filter-ct">
                                                <label>View by:</label>
                                                <select [(ngModel)]="viewBy" class="form-control-sm">
                                                    <option value="c">Competitions</option>
                                                    <option value="t">Time</option>
                                                </select>
                                             </div>
                                        </div>
                                        <app-sport-list *ngIf="tabId == mn.id && (!events.casino.includes(mn.id))" [viewBy]="viewBy" [list]="mn.name.includes('In') ? inPlayData : data" [eventId]="mn.id" [eventName]="mn.name" [oddsData]="oddsLisDis"></app-sport-list>
                                    </div>
                                </div>
                            </div>
                            <app-loader class="no-overlay" *ngIf="isLoad"></app-loader>
                        </div>
                        
                    </div>

                    <!-- <div class="swiper-wrapper d-block d-md-none">
                        <div class="swiper mySwiper">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide slider_banner__item">
                                    <img class="img-fluid slider_banner__item_img" src="https://speedcdn.io/assets/parker-client/landing_casino/auragaming.png" alt="">
                                </div>
                                <div class="swiper-slide slider_banner__item">
                                    <img class="img-fluid slider_banner__item_img" src="https://speedcdn.io/assets/parker-client/landing_casino/aviator.png" alt="">
                                </div>
                                <div class="swiper-slide slider_banner__item">
                                    <img class="img-fluid slider_banner__item_img" src="https://speedcdn.io/assets/parker-client/landing_casino/auragaming.png" alt="">
                                </div>
                                <div class="swiper-slide slider_banner__item">
                                    <img class="img-fluid slider_banner__item_img" src="https://speedcdn.io/assets/parker-client/landing_casino/aviator.png" alt="">
                                </div>
                            </div>
                            <div class="swiper-pagination"></div>
                        </div>
                    </div> -->
                    

                    <div class="row g-4 position-relative" *ngIf="router.url.includes('dashboard')">

                      <!-- Left Sidebar Start -->
                      <div class="col-md-9" *ngFor="let mn of mymenu; let i=index;trackBy:trackByIndex;">
                        <!-- newly added -->
                        <div class="row aura_aviator_banner" *ngIf="router.url.includes('dashboard')">
                          <div class="col-6 position-relative">
                              <a href="javascript:void(0)" (click)="confirmBox(99999, 99999)">
                                  <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/auragaming.png">
                                  <span>Click Here to play</span>
                              </a>
                          </div>
                          <div class="col-6 position-relative">
                              <a href="javascript:void(0)" (click)="confirmBox(99995, 11108)">
                                  <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/aviator.png">
                                  <span>Click Here to play</span>
                              </a>
                          </div>
                        </div>
                      
                        <div class="common-sports">
                            <div class="row">
                                <div class="listuiscreen">
                                    <div class="sub_path">
                                        <p>{{mn.name}} <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/icons/{{mn.id}}.svg"></p>
                                        <div class="filter-ct">
                                            <label>View by:</label>
                                            <select [(ngModel)]="viewBy" class="form-control-sm">
                                                <option value="c">Competitions</option>
                                                <option value="t">Time</option>
                                            </select>
                                          </div>
                                    </div>
                                    <app-sport-list *ngIf="tabId == mn.id && (!events.casino.includes(mn.id))" [viewBy]="viewBy" [list]="mn.name.includes('In') ? inPlayData : data" [eventId]="mn.id" [eventName]="mn.name" [oddsData]="oddsLisDis"></app-sport-list>
                                </div>
                            </div>
                        </div>

                        <app-loader class="no-overlay" *ngIf="isLoad"></app-loader>

                        <!-- racing -->
                        <div class="racing_listing" *ngIf="hRaceList.length > 0">
                          <h2 data-toggle="collapse" href="#S">
                            upcoming horse racing
                          </h2>
                            <div class="collapse show" id="uhr">
                                <div class="race-section">
                                    <a href="javascript:void()" *ngFor="let item of hRaceList;trackBy:trackByIndex;" routerLink="/event/detail/{{item?.event_id}}/{{item?.market_id}}">
                                        <img class="img-fluid" src="https://flagcdn.com/h40/{{item?.event_country_code.toLowerCase()}}.png">
                                        <div class="race_detail">
                                            <small>{{item?.market_start_time_format | date : 'hh:mm a'}}</small>
                                            <span>{{item?.market_name}}</span>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div class="racing_listing" *ngIf="gRaceList.length > 0">
                          <h2 data-toggle="collapse" href="#uhr">
                            upcoming greyhound racing
                          </h2>
                            <div class="collapse show" id="uhr">
                                <div class="race-section">
                                    <a href="javascript:void()" *ngFor="let item of gRaceList;trackBy:trackByIndex;" routerLink="/event/detail/{{item?.event_id}}/{{item?.market_id}}">
                                        <img class="img-fluid" src="https://flagcdn.com/h40/{{item?.event_country_code.toLowerCase()}}.png">
                                        <div class="race_detail">
                                            <small>{{item?.market_start_time_format | date : 'hh:mm a'}}</small>
                                            <span>{{item?.market_name}}</span>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <!-- racing end -->
                        
                      </div> <!--Left Sidebar end -->

                      <!-- <div class="col-md-9">
                          
                          <div class="row mb-1">
                              <div class="col-12">
                                  <img class="img-fluid w-100" src="assets/img/cricket-new.jpg">
                              </div>
                          </div>
                          
                          <div class="position-relative">

                              <app-sport-list [viewBy]="viewBy" [list]="homeData" [eventId]="events.sports[0]" [oddsData]="oddsLisDis"></app-sport-list>

                              <tabset type="pills exch-sports-nav-item">
                                  <tab *ngFor="let mn of mymenu; let i=index;trackBy:trackByIndex;" (selectTab)="onSelect(mn)">
                                      <ng-template tabHeading>
                                          <span class="MuiTab-wrapper">
                                              {{mn.name}} 
                                              <img src="assets/img/{{mn.id}}.png" alt="{{mn.name}}">
                                          </span>
                                      </ng-template>
                                      newly added
                                      <div class="row aura_aviator_banner">
                                          <div class="col-6 position-relative">
                                              <a href="javascript:void(0)" (click)="confirmBox(99999, 99999)">
                                                  <img class="img-fluid" src="assets/img/casino/auragaming.png">
                                                  <span>Click Here to play</span>
                                              </a>
                                          </div>
                                          <div class="col-6 position-relative">
                                              <a href="javascript:void(0)" (click)="confirmBox(99995, 11108)">
                                                  <img class="img-fluid" src="assets/img/casino/aviator.png">
                                                  <span>Click Here to play</span>
                                              </a>
                                          </div>
                                      </div>

                                      <div class="row">
                                          <div class="listuiscreen">
                                              <div class="sub_path">
                                                  <p>{{mn.name}} <img class="img-fluid" src="assets/img/icons/{{mn.id}}.svg"></p>
                                                  <div class="filter-ct">
                                                      <label>View by:</label>
                                                      <select [(ngModel)]="viewBy" class="form-control-sm">
                                                          <option value="c">Competitions</option>
                                                          <option value="t">Time</option>
                                                      </select>
                                                    </div>
                                              </div>
                                              <app-sport-list *ngIf="tabId == mn.id && !events.casino.includes(mn.id)" [viewBy]="viewBy" [list]="data" [eventId]="mn.id" [eventName]="mn.name" [oddsData]="oddsLisDis"></app-sport-list>
                                          </div>
                                      </div>

                                      racing
                                      <div class="racing_listing" *ngIf="hRaceList.length > 0">
                                        <h2 data-toggle="collapse" href="#S">
                                          upcoming horse racing
                                        </h2>
                                          <div class="collapse show" id="uhr">
                                              <div class="race-section">
                                                  <a href="javascript:void()" *ngFor="let item of hRaceList;trackBy:trackByIndex;" routerLink="/event/detail/{{item?.event_id}}/{{item?.market_id}}">
                                                      <img class="img-fluid" src="https://flagcdn.com/h40/{{item?.event_country_code.toLowerCase()}}.png">
                                                      <div class="race_detail">
                                                          <small>{{item?.market_start_time_format | date : 'hh:mm a'}}</small>
                                                          <span>{{item?.market_name}}</span>
                                                      </div>
                                                  </a>
                                              </div>
                                          </div>
                                      </div>

                                      <div class="racing_listing" *ngIf="gRaceList.length > 0">
                                        <h2 data-toggle="collapse" href="#uhr">
                                          upcoming greyhound racing
                                        </h2>
                                          <div class="collapse show" id="uhr">
                                              <div class="race-section">
                                                  <a href="javascript:void()" *ngFor="let item of gRaceList;trackBy:trackByIndex;" routerLink="/event/detail/{{item?.event_id}}/{{item?.market_id}}">
                                                      <img class="img-fluid" src="https://flagcdn.com/h40/{{item?.event_country_code.toLowerCase()}}.png">
                                                      <div class="race_detail">
                                                          <small>{{item?.market_start_time_format | date : 'hh:mm a'}}</small>
                                                          <span>{{item?.market_name}}</span>
                                                      </div>
                                                  </a>
                                              </div>
                                          </div>
                                      </div>
                                      racing end

                                      <app-casino *ngIf="tabId == mn.id && events.casino.includes(mn.id)" [casinoId]="mn.id"></app-casino>
                                      
                                  </tab>
                                  <app-loader class="no-overlay" *ngIf="isLoad"></app-loader>
                              </tabset>

                              
                          </div>

                      </div> -->
                      <!-- Right Sidebar Start -->
                      <div class="col-md-3 d-none d-md-block">
                          <div class="row">
                              <div class="col-md-12">
                                  <div class="row d-xs-none">
                                      <!-- <div class="col-md-12 bg-warning "> Matched </div> -->
                                      <div class="col-md-12 hovereffect mt-1">
                                          <img class="card-img-top img-fluid" src="https://speedcdn.io/assets/parker-client/andar-bahar.jpg">
                                          <div class="overlay">
                                              <a href="javascript:void(0)" class="info pt-1 pb-1" (click)="confirmBox(99999, 87565)">Play</a>
                                          </div>
                                      </div>
                                      <div class="col-md-12 hovereffect mt-1">
                                          <img class="card-img-top img-fluid" src="https://speedcdn.io/assets/parker-client/baccarat.jpg">
                                          <div class="overlay">
                                              <a href="javascript:void(0)" class="info pt-1 pb-1" (click)="confirmBox(99999, 92038)">Play</a>
                                          </div>
                                      </div>
                                      <div class="col-md-12 hovereffect mt-1">
                                          <img class="card-img-top img-fluid" src="https://speedcdn.io/assets/parker-client/poker.jpg">
                                          <div class="overlay">
                                              <a href="javascript:void(0)" class="info pt-1 pb-1" (click)="confirmBox(99999, 56766)">Play</a>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <!-- Right Sidebar End -->
                    </div>

                    <!-- casino -->
                    <app-casino [casinoId]="events.casino1[0]" [isDashboard]="true"></app-casino>
                    
                </div>
            </div>
        </div>
    </div>
</div>